import { useDtfStore } from "../../store";
import { cn } from "tailwind-variants";
import Headline from "../components/Headline.vue";
import Section from "../components/Section.vue";
import TrimInfo from "../../TrimInfo.vue";
import "./PrintPerfect.scss";

export default function PrintPerfect({
  artwork,
  reorderEnabled,
  paidExpertEditAddonEnabled,
  index
}) {
  const store = useDtfStore();

  function isStandardDTFProduct() {
    return store.isStandardDTFProduct;
  }

  return (
    <>
      <Headline
        className="print-perfect__headline scope-53dc0233"
        slots={{
          title: () => <>Image Enhanced by Jiffy AI</>,
          subtitle: () => <>Background removal, upscaling, sharpening edges.</>
        }}
        data-testid="print-perfect-headline"
      >
        <span
          className={cn("scope-53dc0233", "print-perfect__free-text", {
            "print-perfect__free-text--experiment": isStandardDTFProduct()
          })}
        >
          {" "}
          FREE{" "}
        </span>
      </Headline>
      {artwork.canRemoveBg ? (
        <Section
          className="print-perfect__controls-section print-perfect__addon-container scope-53dc0233"
          data-testid="print-perfect-controls-section"
        >
          {artwork.canRemoveBg && !artwork.isFile && !artwork.isSimulated ? (
            <TrimInfo
              className="scope-53dc0233"
              id={artwork.id}
              artwork={artwork}
              activeConfigSection="jiffy-print-perfect"
              canRemoveBg={artwork.canRemoveBg}
              removeBackground={artwork.removeBackground}
              toggleBackgroundError={artwork.toggleBackgroundError || ""}
              data-testid="trim-info"
            />
          ) : null}
        </Section>
      ) : null}
    </>
  );
}
